export default {

  // Controle de Login
  user: null,
  authToken: null,
  uploadToken: null,
  loggingIn: false,

  // Mensagens/Notificações
  updateMessages: false,
  updateNotifications: false,

  // Dashboard
  openQuotationsChartData: null,
  consolidatedQuotationsChartData: null,
  quotationsWaitingConfirmationChartData: null,

  // Consulta de Produtos
  products: [],
  bitolas: [],
  colors: [],
  balances: null,
  balancesFilter: null,

  // Reservas
  reserves: null,
  reservesFilter: null,
  reservesCustomers: [],
  reservesSellers: [],
  reservesUsers: [],

  // Consulta de Clientes
  customers: null,
  customersFilter: null,
  segments: [],

  // Orçamentos
  quotations: null,
  quotationsFilter: null,
  quotationsUsers: [],
  quotationsSellers: [],
  quotationsManagers: [],
  quotationsCompetitors: [],
  quotationsAttachmentsCategories: [],
}
